import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'PlayBackButton' })({
    root: {
        width: 40,
        height: 40,
        boxSizing: 'border-box',
        color: '#FFFFFF',
        background: 'rgba(45, 45, 45, 0.50)',
        backdropFilter: 'blur(calc(var(--base-x15, 8px) / 2))',
        ['&:hover']: {
            background: 'rgba(45, 45, 45, 0.35)'
        }
    }
});
